import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IDeleteShortlistCandidatePayload } from '../types';

export const deleteShortlistCandidate = async (
  payload: IDeleteShortlistCandidatePayload,
): Promise<void> => {
  const headers = await getAuthHeaders();

  await tempMeeApi.delete<void>(
    `/recruitment-service/candidates/${payload.candidateId}/shortlist`,
    { headers },
  );
};
